/**
 * collapse creates the on click listener for '.js-collapse-element' and '.js-collapse-elements'.
 *
 * The '.js-collapse-element' on click listener toggles the class 'is-collapsed' on the given element and toggles the class 'fa-flip-vertical' on the given icon.
 * The 'js-toggle-class' element requires:
 * - data-collapse-element: String      (Element to collapse, ie '#element' or '.element')
 * - data-collapse-icon: String         (Optional icon that indicates the collapse, ie '#element' or '.element')
 *
 * The '.js-collapse-elements' on click listener toggles and syncs the class 'is-collapsed' on the given element based on the first in given element,
 * toggles and syncs the class 'fa-flip-vertical' on the given icon based on the first in given element.
 * The 'js-toggle-class' element requires:
 * - data-collapse-element: String      (Element to collapse, ie '#element' or '.element')
 * - data-collapse-icon: String         (Optional icon that indicates the collapse, ie '#element' or '.element')
 */

function collapse() {
	const isCollapsedClass = 'is-collapsed';
	const iconClass = 'fa-flip-vertical';

	$(document).on('click', '.js-collapse-element', function() {
		const $this = $(this);
		const $target = $($this.data('collapse-element'));
		const $icon = $($this.data('collapse-icon'));

		const isCollapsed = $target.hasClass(isCollapsedClass);

		if (!isCollapsed) {
			$target.addClass(isCollapsedClass);
			if ($icon != undefined) {
				$icon.addClass(iconClass);
			}
		} else {
			$target.removeClass(isCollapsedClass);
			if ($icon != undefined) {
				$icon.removeClass(iconClass);
			}
		}
	});

	$(document).on('click', '.js-collapse-elements', function() {
		const $this = $(this);
		const $target = $($this.data('collapse-element'));
		const $icon = $($this.data('collapse-icon'));

		/* Base whether or not all should be collapsed or not-collapsed on the state of the first element */
		const isCollapsed = $target.first().hasClass(isCollapsedClass);

		/* Then, if the first element was NOT collapsed, then collapse all by adding the class */
		if (!isCollapsed) {
			$target.addClass(isCollapsedClass);
			if ($icon != undefined) {
				$icon.addClass(iconClass);
			}
		} else {
			$target.removeClass(isCollapsedClass);
			if ($icon != undefined) {
				$icon.removeClass(iconClass);
			}
		}
	});
}
collapse();
